<template>
  <div>
    <div>Tipo Documento</div>
    <q-select
      v-model="dados.documento"
      dense
      outlined
      :options="options"
      @filter="filterFn"
    />
  </div>
</template>

<script>
import { useStore } from "vuex";
import { ref, watch } from "vue";
export default {
  emits: ["enviarTipoDocumento"],
  props: ["value", "resetar"],
  setup(props, { emit }) {
    const store = useStore();

    const dados = ref({ documento: props.value });
    const options = ref([]);

    const listarTiposDocumento = async () => {
      await store.state.org.unidadeData.id;
      try {
        const response = await store.dispatch("fer/listarTiposDocumento", {
          vendor_id: store.state.org.unidadeData.id,
        });
        options.value = response.data.result[0].tipo_documento;
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => dados.value.documento,
      () => {
        emit("enviarTipoDocumento", dados.value.documento);
      }
    );

    watch(
      () => props.resetar,
      () => {
        dados.value.documento = "";
      }
    );

    return {
      listarTiposDocumento,
      dados,
      options,
      filterFn(val, update) {
        listarTiposDocumento();
        setTimeout(() => {
          update();
        }, 1000);
      },
      abortFilterFn() {
        // console.log('delayed filter aborted')
      },
    };
  },
};
</script>
